module.exports = __webpack_public_path__ + "static/img/dkzg2.3cff637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/dkzg2.jpg
// module id = SwUb
// module chunks = 0